import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchAll({ crewParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `Crew/GetSearched`,
      params: crewParams,
    });
    const allCrews = data.toJS();
    yield put(Actions.setAll({ allCrews }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err);
  }
}
function* fetchCrewRotaByFactory({ filters }) {
  try {
    const { selectedFactory, fromDate, toDate } = filters;
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `Crew/crewRota/${selectedFactory}/${fromDate.toDateString()}/${toDate.toDateString()}`,
    });
    const crewRotaData = data?.toJS();
    yield put(Actions.setCrewRota({ crewRotaData }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    notification('error', err, '');
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(err);
  }
}
function* isCrewNameExists({ name, factoryId, id, callback }) {
  try {
    const { data } = yield call(api.get, {
      route: `Crew/isCrewNameExists/${name}/${id ?? null}`,
    });

    yield put(Actions.setIsCrewNameExists({ isCrewExists: data }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err);
  }
}

function* addCrew({ crew, crewParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.post, {
      route: `crew`,
      data: crew,
    });
    yield put(Actions.fetchAll({ crewParams }));
    notification('success', CONSTANT_VARIABLES.CREW_CREATED, '');
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}
function* importExcelRotaFile({ importFileParams, filters }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield put(Actions.setUploadResponse({ uploadResponse: null }));
    const response = yield call(api.post, {
      route: `crew/uploadCrewRota/` + filters.selectedFactory,
      data: importFileParams.file,
    });
    let result = response.data.toJS();
    if (!result.fileStructureError && !result.errorItems && result.successCount > 0) {
      notification('success', CONSTANT_VARIABLES.CREW_ROTA_UPLOADED, '');
    }

    yield put(Actions.fetchCrewRotaByFactory({ filters }));
    yield put(Actions.setUploadResponse({ uploadResponse: result }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* updateCrew({ crew, crewParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.put, {
      route: `crew`,
      data: crew,
    });
    yield put(Actions.fetchAll({ crewParams }));
    notification('success', CONSTANT_VARIABLES.CREW_UPDATED, '');
    yield put(Actions.setLoader({ showLoader: true }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* deleteCrew({ id, crewParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.delete, {
      route: `crew/` + id,
    });
    yield put(Actions.fetchAll({ crewParams }));
    notification('success', CONSTANT_VARIABLES.CREW_DELETED, '');
    yield put(Actions.setLoader({ showLoader: true }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([takeLatest(ActionTypes.FETCH_ALL, fetchAll)]);
  yield all([takeLatest(ActionTypes.ADD_CREW, addCrew)]);
  yield all([takeLatest(ActionTypes.UPDATE_CREW, updateCrew)]);
  yield all([takeLatest(ActionTypes.DELETE_CREW, deleteCrew)]);
  yield all([takeLatest(ActionTypes.FETCH_CREW_ROTA_DATA_BY_FACTORY, fetchCrewRotaByFactory)]);
  yield all([takeLatest(ActionTypes.IMPORT_EXCEL_CREW_ROTA, importExcelRotaFile)]);
  yield all([takeLatest(ActionTypes.FETCH_IS_CREW_NAME_EXISTS, isCrewNameExists)]);
}
